import React, { Suspense, useLayoutEffect } from 'react'
import { BrowserRouter as Router, Route, Switch, withRouter } from 'react-router-dom';

// Homepages
const Home = React.lazy(() => import("./components/pages/Home"));
const Hometwo = React.lazy(() => import("./components/pages/Hometwo"));
const Homethree = React.lazy(() => import("./components/pages/Homethree"));
const Homefour = React.lazy(() => import("./components/pages/Homefour"));
const Homefive = React.lazy(() => import("./components/pages/Homefive"));
const Homesix = React.lazy(() => import("./components/pages/Homesix"));
// About
const About = React.lazy(() => import("./components/pages/About"));
// Blog
const Blog = React.lazy(() => import("./components/pages/Blog"));
const Blogleft = React.lazy(() => import("./components/pages/Blogleft"));
const Blogdetails = React.lazy(() => import("./components/pages/Blogdetails"));
// Contact
const Contact = React.lazy(() => import("./components/pages/Contact"));
// Gallery
const Gallery = React.lazy(() => import("./components/pages/Gallery"));
// History
const History = React.lazy(() => import("./components/pages/History"));
// Menu
const Menu = React.lazy(() => import("./components/pages/Menu"));
// Team
const Team = React.lazy(() => import("./components/pages/Team"));
// Reservation
const Reservation = React.lazy(() => import("./components/pages/Reservation"));
// Chef
const Chef = React.lazy(() => import("./components/pages/Chef"));
// Typography
const Typography = React.lazy(() => import("./components/pages/Typography"));

// Scroll to Top
const ScrollToTop = withRouter(({ children, location: { pathname } }) => {
  useLayoutEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return children || null
})

function App() {
  return (
    <Router basename={"/"}>
      <Suspense fallback={<div></div>}>
        <ScrollToTop>
          <Switch>
            {/* Home */}
            <Route exact path="/" component={Home} />
            <Route exact path="/home-v2" component={Hometwo} />
            <Route exact path="/home-v3" component={Homethree} />
            <Route exact path="/home-v4" component={Homefour} />
            <Route exact path="/home-v5" component={Homefive} />
            <Route exact path="/home-v6" component={Homesix} />
            {/* About */}
            <Route exact path="/about" component={About} />
            {/* Blog */}
            <Route exact path="/blog/cat/:catId" component={props => (<Blog {...props} key={window.location.pathname} />)} />
            <Route exact path="/blog/tag/:tagId" component={props => (<Blog {...props} key={window.location.pathname} />)} />
            <Route exact path="/blog/author/:authorId" component={props => (<Blog {...props} key={window.location.pathname} />)} />
            <Route exact path="/blog/search/:query" component={props => (<Blog {...props} key={window.location.pathname} />)} />
            <Route exact path="/blog" component={Blog} />
            <Route exact path="/blog-left" component={Blogleft} />
            <Route exact path="/blog-details/:id" component={props => (<Blogdetails {...props} key={window.location.pathname} />)} />
            {/* Contact */}
            <Route exact path="/contact" component={Contact} />
            {/* Gallery */}
            <Route exact path="/gallery" component={Gallery} />
            {/* History */}
            <Route exact path="/history" component={History} />
            {/* Menu */}
            <Route exact path="/menu" component={Menu} />
            {/* Team */}
            <Route exact path="/team" component={Team} />
            {/* Reservation */}
            <Route exact path="/reservation" component={Reservation} />
            {/* Chef */}
            <Route exact path="/chef" component={Chef} />
            {/* Typography */}
            <Route exact path="/typography" component={Typography} />
          </Switch>
        </ScrollToTop>
      </Suspense>
    </Router>
  );
}

export default App;
